export default __webpack_public_path__ + "static/media/client-21.1d12f06e.webp";